import React from "react";

export class FieldWrapper extends React.PureComponent {
    render() {
        return <div className="form-group">{this.props.children}</div>;
    }
}